<header class="mast-main-head fixed-top">

  <!-- <div class="main-header-subscriber-offer-section">
    <span>🎉 Celebratings! <strong>50k+</strong> users & <strong>2K+</strong> happy subscribers.<b routerLink="/happy-subscribers"> What's in? </b> <img class="arrow" src="assets/img/arrow-right.svg" alt=""> <img class="illus-img" src="assets/img/online-cab.png" alt=""> <img class="illus-img" src="assets/img/team-art.svg" alt=""> <img class="illus-img" src="assets/img/yoga.png" alt=""></span></div> -->

  <nav class="navbar navbar-expand-lg remove-shadow" id="mainNav">
    <div class="container">
      <a class="navbar-brand js-scroll-trigger" href="javascript:;" routerLink="/home"><img src="assets/img/logo.svg"></a>
      <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
      </button>
      <div class="collapse navbar-collapse" id="navbarResponsive">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <a class="nav-link marketplace" routerLink="/how-it-works" style="cursor: pointer;">How it works</a>
          </li>
          <li class="nav-item">
            <a class="nav-link marketplace" (click)="openMarketplace()" style="cursor: pointer;">Marketplace</a>
          </li>
          <li class="nav-item">
            <a class="nav-link marketplace" routerLink="/pricing">Pricing</a>
          </li>
          <li class="nav-item dropdown col-1-dropdown">
            <a class="nav-link dropdown-toggle marketplace" data-toggle="dropdown">Plugins</a>
            <div class="dropdown-menu" style="width: 200px;">
              <ul>
                <li><a style="color: #000" class="nav-link" href="https://www.figma.com/community/plugin/902086023682633830/Crafttor" target="_blank">
                  <img src="assets/img/ic-figma.png" alt=""> <span>Figma</span> </a>
                  <!-- <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="Icons/Navigation/Arrow Down/Black">
                      <g id="Group">
                        <path id="down_arrow" d="M18.5 9.44444L12.3274 15L6 9.57345" stroke="#b2b2b2" stroke-linecap="round" stroke-linejoin="round"/>
                      </g>
                    </g>
                  </svg> -->
                </li>
                <li><a style="color: #000" class="nav-link" href="https://crafttor.com/sketch" target="_blank">
                  <img src="assets/img/ic-sketch.png" alt=""> <span>Sketch</span> </a></li>
                <li><a style="color: #000" class="nav-link" href="https://exchange.adobe.com/apps/cc/109306/crafttor-for-illustrator" target="_blank">
                  <img src="assets/img/ai.png" alt="" style="width: 20px; height: 20px; margin-left: 4px;"> <span>Illustrator</span> </a></li>
              </ul>
            </div>
          </li>
          <li class="nav-item">
            <a class="nav-link marketplace" href="https://crafttor.com/blogs" target="_blank">Blog</a>
          </li>
           <li class="nav-item signup-btn">
          <a class="nav-link button" href="profile.html" data-toggle="modal" routerLink="/login">Start for free</a>
          </li>
          <li class="nav-item login-btn">
          </li>
        </ul>
      </div>
    </div>
  </nav>
</header>

<section class="feature-custom-section">
	<div class="container">
		<div class="row">
			<div class="col-sm-6">
				<div class="inner-content">
          <h1>Integration Makes Life Easy</h1>
          <p>Integrating with tools like Figma, Sketch, and Illustrator lets your team seamlessly access and manage your organisation's assets directly within these design platforms.</p>
					<div class="btn-wrapper">
						<a class="gray-btn" (click)="openLetsTalkDialog(letsTalk)">Book Demo</a>
					</div>
				</div>
			</div>
      <div class="col-sm-6 detailed-pages-img">
        <img src="assets/img/feat.png" style="background-color: #efefef; border-radius: 10px;">
      </div>
		</div>
	</div>
</section>

<section class="features-sections">
  <h3 class="main-title">Consistent across connected systems</h3>
  <div class="container">
    <div class="row">
      <div class="col-sm-5 central-txt">
        <h3 class="header-text-left">Figma plugin</h3>
        <p class="feature-content-left">Figma plugin is for designers to create amazing landing
          pages for their products. An illustration is a creative way
          to fill white space in web design and catch your reader’s
          attention. There are multiple plans for designers,
          so everyone can accomplish their aspirations.</p>
        <a href="https://crafttor.com/figma" target="_blank"><span>Know more
          <svg _ngcontent-tbs-c85="" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path _ngcontent-tbs-c85="" d="M12.1251 19L19 12L12.1251 5" stroke="#2d7cff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path _ngcontent-tbs-c85="" d="M5 12L18.1255 12" stroke="#2d7cff" stroke-width="1.5" stroke-linecap="round"></path></svg>
        </span></a>
      </div>
      <div class="col-sm-1">
      </div>
      <div class="col-sm-6 plugin-designss">
        <img class="contact-plugin-img" src="assets/img/plugin-pic.png" alt="figma illustration">
        <img data-aos="fade-right" data-aos-easing="linear" data-aos-duration="1000" src="assets/img/figma-plugin.png" alt="figma image" class="figma-img">
      </div>
    </div>
  </div>
</section>

<section class="features-sections space-above" style="background: none;">
  <div class="container">
    <div class="row">
      <div class="col-sm-6 feature-areas plugin-designsss" style="margin-bottom: 0px;">
        <img data-aos="fade-right" data-aos-easing="linear" data-aos-duration="1000" src="assets/img/sketch-plugin.png" alt="figma image" class="figma-img">
        <img class="contact-plugin-img" src="assets/img/plugin-pic.png">
      </div>
      <div class="col-sm-1">
      </div>
      <div class="col-sm-5 central-txt">
        <h3 class="header-text-right version-txt">Sketch plugin</h3>
        <p class="feature-content-right">Sketch plugin is designed with a new idea & not preconceived for keeping designers engage with their products. The interface fits every desire & easy to learn and use. The concept include lots of pratical value. Crafttor kept everything simple to utilise & removed the complications of using a plugin.</p>
        <a href="https://crafttor.com/sketch" target="_blank"><span>Know more
          <svg _ngcontent-tbs-c85="" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path _ngcontent-tbs-c85="" d="M12.1251 19L19 12L12.1251 5" stroke="#2d7cff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path _ngcontent-tbs-c85="" d="M5 12L18.1255 12" stroke="#2d7cff" stroke-width="1.5" stroke-linecap="round"></path></svg>
        </span></a>
      </div>
    </div>
  </div>
</section>

<section class="features-sections space-above" style="background: none;">
  <div class="container">
    <div class="row">
      <div class="col-sm-5 central-txt">
        <h3 class="header-text-left">AI plugin</h3>
        <p class="feature-content-left">We believe in never giving up because great things take time. Go with our illustrator plugin & design for life. Be a mind blowing illustrator with our plugin. It is very easy to use & even easy to handle and manage while designing your thoughts.</p>
        <a href="https://crafttor.com/illustrator" target="_blank"><span>Know more
          <svg _ngcontent-tbs-c85="" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path _ngcontent-tbs-c85="" d="M12.1251 19L19 12L12.1251 5" stroke="#2d7cff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path _ngcontent-tbs-c85="" d="M5 12L18.1255 12" stroke="#2d7cff" stroke-width="1.5" stroke-linecap="round"></path></svg>
        </span></a>
      </div>
      <div class="col-sm-1">
      </div>
      <div class="col-sm-6 feature-areas plugin-designss">
        <img class="contact-plugin-img" src="assets/img/plugin-pic.png">
        <img data-aos="fade-right" data-aos-easing="linear" data-aos-duration="1000" src="assets/img/ai.png" alt="figma image" class="figma-img">
      </div>
    </div>
  </div>
</section>

<section class="plugin-section" style="margin-top: 100px;">
	<div class="container">
		<div class="row">
			<div class="col-sm-12 text-center">
				<h3>Connecting with the plugins you love</h3>
			</div>
			<div class="col-sm-6">
				<div class="icon">
					<img src="assets/img/figma.png">
				</div>
				<p>Design an elegant way to put everything to create amazing landing pages for your products.</p>
				<a href="https://www.figma.com/community/plugin/902086023682633830" target="_blank" class="button">Install Figma</a>
			</div>
			<div class="col-sm-6">
				<div class="icon">
					<img src="assets/img/sketch.png">
				</div>
				<p>Draw the most desired and spontaneous expressions and engage people with your products.</p>
				<!-- <a href="https://crafttor.com/sketch" target="_blank" class="button">Download Sketch</a> -->
        <a href="{{sketchData.download}}" download class="button">Download Sketch ( {{sketchData.version}} )</a>
			</div>
      <div class="col-sm-6">
				<div class="icon">
					<img src="assets/img/ai.png">
				</div>
				<p>Create more innovative illustration concepts and show what other wants to see.</p>
				<a href="https://exchange.adobe.com/apps/cc/109306/crafttor-for-illustrator" class="button">Install Illustrator</a>
			</div>
			<div class="col-sm-6">
				<div class="icon">
					<img src="assets/img/xd.png">
				</div>
				<p>Change the atmosphere of assets with different lighting to make it look more interesting.</p>
				<a href="javascript:;" class="button">Coming soon</a>
			</div>
			<div class="col-sm-12 text-center">
				<a href="javascript:;" class="button gray-btn">Many More to Come</a>
			</div>
		</div>
	</div>
  </section>

<section class="signup-section" style="margin-top: 0px;">
  <div class="container">
    <div class="row">
      <div class="col-sm-12 text-center">
        <div class="inner">
          <h2>Work together seamlessly</h2>
          <a class="button demo-btn" (click)="openLetsTalkDialog(letsTalk)">Book Demo</a>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Footer -->
<footer class="site-footer">
  <div class="container">
    <div class="row">
      <div class="col-sm-3">
        <div class="coulmn-1">
  				<img src="assets/img/logo.svg">
  				<p>Digital assets management</p>
  				<a href="mailto:info@crafttor.com"><i class="fa fa-envelope" aria-hidden="true"></i> info@crafttor.com</a>
  			</div>
      </div>
      <!-- 3 -->
      <div class="col-sm-2">
        <h5>Products</h5>
        <ul class="menu">
          <li><a routerLink="/home">Workspace</a></li>
          <li><a (click)="openMarketplace()">Marketplace</a></li>
          <li><a routerLink="/features">Features</a></li>
          <li><a routerLink="/mobile-apps">Crafttor for Mobile</a></li>
<li><a routerLink="/smart-storage">Smart storage</a></li>
          <li><a routerLink="/effective-search">Effective search</a></li>

        </ul>
      </div>

      <div class="col-sm-2">
        <h5>Plugins</h5>
        <ul class="menu">
          <li><a href="https://www.figma.com/community/plugin/902086023682633830/Crafttor" target="_blank">Figma</a></li>
          <li><a href="https://crafttor.com/sketch" target="_blank">Sketch</a></li>
          <li><a href="https://exchange.adobe.com/apps/cc/109306/crafttor-for-illustrator" target="_blank">Illustrator</a></li>
          <li><a href="https://www.figma.com/community/plugin/1408354139656199596/kaleidoscope" target="_blank">Kaleidoscope</a></li>
          <li><a href="https://www.figma.com/community/plugin/1406167507218530657/iso-all" target="_blank">Iso All</a></li>
          <li><a href="https://www.figma.com/community/plugin/1409844094149025473/translate-ai" target="_blank">Translate AI</a></li>
          <li><a href="https://www.figma.com/community/plugin/1417763374654877658/image-to-figma-design-beta" target="_blank">Image to Figma</a></li>
<li><a href="https://www.figma.com/community/plugin/1409553168281102402/bannners" target="_blank">Bannners</a></li>
        </ul>
      </div>

      <div class="col-sm-2">
        <h5>Solutions</h5>
        <ul class="menu">
          <li><a routerLink="/dropbox-alternative">Dropbox alternative</a></li>
          <li><a routerLink="/google-drive-alternative">G Drive alternative</a></li>
          <li><a routerLink="/box-alternative">Box alternative</a></li>
          <li><a routerLink="/content-library">Content library</a></li>
          <li><a routerLink="/user-profiling">User Profiling</a></li>
<li><a routerLink="/approvals">Creative approvals</a></li>
        </ul>
      </div>

      <div class="col-sm-2">
        <h5>Features</h5>
        <ul class="menu">
          <li><a routerLink="/features/tagging">Tagging</a></li>
          <li><a routerLink="/features/sharing">Sharing</a></li>
          <li><a routerLink="/features/versioning">Versioning</a></li>
          <li><a routerLink="/features/collaboration">Collaboration</a></li>
          <li><a routerLink="/features/integration">Integration</a></li>
        </ul>
      </div>

      <div class="col-sm-2">
        <h5>Company</h5>
        <ul class="menu">
          <li><a routerLink="/about-workspace">About Workspace</a></li>
          <li><a routerLink="/contact">Contact Us</a></li>
          <li><a routerLink="/terms">Terms & Conditions</a></li>
          <li><a routerLink="/faq">FAQ</a></li>
          <li><a routerLink="/feedbacks">Feedback</a></li>
          <li><a href="https://crafttor.com/blogs" target="_blank">Blog</a></li>
          <li><a routerLink="/our-mission">Our mission</a></li>
          <li><a routerLink="/partner-with-us">Partner with us</a></li>
        </ul>
      </div>

      <div class="col-sm-3 all-social-icons">
        <h5>Socials</h5>
        <ul class="social-icons">
          <li><a rel="nofollow" href="https://www.facebook.com/Crafttor-Studio-102023868185724/?modal=admin_todo_tour" target=”_blank”
            alt="facebook"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
          <li><a rel="nofollow" href="https://twitter.com/CrafttorS" target=”_blank” alt="twitter"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
          <li><a rel="nofollow" href="https://www.linkedin.com/company/crafttor/" target=”_blank” alt="linkedin"><i class="fa fa-linkedin" aria-hidden="true"></i></a></li>
          <li><a rel="nofollow" href="https://www.instagram.com/crafttorstudio/" target=”_blank” alt="instagram"><i class="fa fa-instagram" aria-hidden="true"></i></a></li>
          <li><a rel="nofollow" href="https://www.youtube.com/channel/UC6SM1D8MU7uwLVEC8uFDW-w/?guided_help_flow=5" target=”_blank” alt="youtube"><i class="fa fa-youtube-play" aria-hidden="true"></i></a></li>
          <li><a rel="nofollow" href="https://dribbble.com/crafttorstudio" target=”_blank” alt="dribbble"><i class="fa fa-dribbble" aria-hidden="true"></i></a></li>
          <li><a rel="nofollow" href="https://www.behance.net/crafttorstudio" target=”_blank” alt="behance"><i class="fa fa-behance" aria-hidden="true"></i></a></li>
        </ul>
      </div>

      <div class="col-sm-12 text-center">
  			<small>&copy; 2025 Crafttor. All rights reserved</small>
  		</div>
    </div>
  </div>
</footer>

<ng-template #letsTalk let-letsTalk>
    <div class="custom-dialog custom-dialog-centered sign-up" role="document">
      <div class="modal-content">
        <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <img src="assets/img/cross.svg" (click)="letsTalk.close()">
          </button>
        <div class="modal-body">
      <h2>Let's talk!</h2>
      <p>Schedule a free demo today. We will show you a demo of how Crafttor Workspace works.</p>
      <div class="form-wrapper">
        <form class="row g-3" [formGroup]="letsTalkForm" (ngSubmit)="submitContactUs(selectDate)">
          <div class="col-md-6">
          <label class="form-label">First Name<span>*</span></label>
          <input id="textinput" formControlName="name" type="text" placeholder="Brian" class="form-control input-md" required>
          <span class="text-danger error-text"
          *ngIf="(letsTalkForm.controls.name.touched || submitted) && letsTalkForm.controls.name.errors?.required">
          First Name is required
        </span>
          </div>
          <div class="col-md-6">
          <label class="form-label">Last Name<span>*</span></label>
          <input id="textinput" formControlName="lname" type="text" placeholder="Storm" class="form-control input-md" required>
          <span class="text-danger error-text"
          *ngIf="(letsTalkForm.controls.lname.touched || submitted) && letsTalkForm.controls.lname.errors?.required">
          Last Name is required
        </span>
          </div>
          <div class="col-12">
          <label for="businessEmail" class="form-label">Business Email<span>*</span></label>
          <input id="textinput" formControlName="email" type="email" placeholder="abc@crafttor.com" class="form-control input-md" >
          <span class="text-danger error-text"
          *ngIf="(letsTalkForm.controls.email.touched || submitted) && letsTalkForm.controls.email.errors?.required">
          Email is required
        </span>
        <span class="text-danger error-text"
        *ngIf="(letsTalkForm.controls.email.touched || submitted) && letsTalkForm.controls.email.errors?.pattern">
        Email is not valid
      </span>
          </div>
          <div class="col-12">
          <label for="company" class="form-label">Company<span>*</span></label>
          <input id="textinput" formControlName="company" type="text" placeholder="Crafttor" class="form-control input-md" >
          <span class="text-danger error-text"
          *ngIf="(letsTalkForm.controls.company.touched || submitted) && letsTalkForm.controls.company.errors?.required">
          Company Name is required
        </span>
          </div>

          <div class="col-md-12" style="display: none;">
            <label class="form-label" for="textarea">Message</label>
            <input id="textinput" formControlName="message" type="text" class="form-control input-md" required>
            <span class="text-danger error-text"
            *ngIf="(letsTalkForm.controls.message.touched || submitted) && letsTalkForm.controls.message.errors?.required">
            Message is required
          </span>
          </div>


          <div class="col-12">
          <button id="singlebutton" name="singlebutton button" class="btn btn-primary" *ngIf="!showLeaveLoader">Submit</button>
          <button id="singlebutton" name="singlebutton button" class="btn btn-primary" *ngIf="showLeaveLoader"><img src="assets/img/img-up-white.svg" alt="" style="height: 18px;"></button>
          </div>
        </form>
      </div>
      <p>By Submiting the form, You agree to our <a routerLink="/terms" target="_blank">Terms of Service</a> and acknowledge our <a routerLink="/terms" target="_blank">Privacy Policy</a>.</p>
        </div>
      </div>
    </div>
    </div>
</ng-template>


<ng-template #selectDate let-selectDate>
    <div class="custom-dialog custom-dialog-centered select-time-popup" role="document">
      <div class="modal-content">
        <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <img src="assets/img/cross.svg" (click)="selectDate.close()">
          </button>
        <div class="modal-body">
      <h6>{{thankYouText}}</h6>
      <h6>(IST)</h6>
      <div class="form-wrapper">
        <ul class="date-listing" *ngFor="let slots of availableSlots | slice:1:5; let i = index">
          <li *ngIf="showDate">
            <div class="date-list" (click)="selectDateSales(slots.date, slots.day, slots.month)">
              <!-- <div class="date-list-day" style="background: #f9f9f9">
                <a href="javascript:;">{{slots.day}}</a>
              </div> -->
              <div class="">
                <a href="javascript:;">{{slots.month}} {{slots.date1}}</a>
              </div>
              <!-- <a href="javascript:;">{{slots.month}}</a> -->
            </div>
          </li>
        </ul>

        <div *ngIf="!showDate" class="selected-date">
          <div class="date-list-days">
            <a href="javascript:;">{{shownDay}}</a>
          </div>
          <div style="padding-top:10px;" class="">
            <a href="javascript:;">{{shownDate}}</a>
          </div>
          <!-- <a href="javascript:;">{{shownMonth}}</a> -->
        </div>

        <p *ngIf="!showDate" (click)="changeDate()" class="change-date-txt">Change Date</p>

        <h6 style="margin-top:20px;" *ngIf="showTime">What time works?</h6>

        <ul *ngFor="let time of availableTimeSlots; let i = index">
          <li *ngIf="showTime">
            <div class="time-list" (click)="selectTimeSales(time)">
              <div style="text-align: center;" class="">
                <a href="javascript:;">{{time}}</a>
              </div>
            </div>
          </li>
        </ul>
        <div *ngIf="showFinalTime" style="text-align: center;" class="selected-time">
          <a href="javascript:;">{{shownTime}}</a>
        </div>
        <p *ngIf="!showTime" (click)="changeTime()" class="change-time-txt"></p>
        <button id="singlebutton" name="singlebutton button" class="btn btn-primary" *ngIf="!timeSelected && !dateSelected && showSubmitBtn" (click)="contactSalesCall(thankyou)">Submit</button>
        <button id="singlebutton" name="singlebutton button" class="btn btn-primary" *ngIf="!timeSelected && dateSelected && showSubmitBtn" (click)="contactSalesCall(thankyou)">Submit</button>
        <button id="singlebutton" name="singlebutton button" class="btn btn-primary" *ngIf="timeSelected && !dateSelected && showSubmitBtn" (click)="contactSalesCall(thankyou)">Submit</button>
        <button id="singlebutton" name="singlebutton button" class="btn btn-primary" (click)="contactSalesCall(thankyou); selectDate.close()" *ngIf="timeSelected && dateSelected && showSubmitBtn">Submit</button>
        <p *ngIf="showSelectionMessage" class="text-danger error-text" style="text-align: center; margin-top:10px; font-weight: 600">{{showSelectedMsg}}</p>
      </div>
      <p>By Submiting the form, You agree to our <a routerLink="/terms" target="_blank">Terms of Service</a> and acknowledge our <a routerLink="/terms" target="_blank">Privacy Policy</a>.</p>
        </div>
      </div>
    </div>
    </div>
</ng-template>

<ng-template #showloader let-showloader>
  <div class="custom-dialog custom-dialog-centered show-loader" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <img class="main-loader-img" style="margin-top: 200px; width: 180px;" src="assets/img/loader.svg" alt="">
        <h6 style="font-size: 16px;">Please wait</h6>
        <p>Confirming your meeting time..</p>
      </div>
  </div>
</div>
</ng-template>


<ng-template #thankyou let-thankyou>
  <div class="custom-dialog custom-dialog-centered thanks-popup" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <h5>Thank you <br>Your meeting is confirmed. </h5>
          <div class="conver-grid">
            <div class="img-wrapper">
              <img src="" >
              <img src="assets/img/tick.png" class="tick">
            </div>
          <p>You are meeting with</p>
          <h4>Sandeep Virk</h4>
          </div>
      <div class="invitation-wrapper">
        <div class="">You will receive a meeting invitation shortly</div>
          <table>
          <tbody>
            <tr>
              <th>Event</th>
              <td>Crafttor intro with Sandeep</td>
            </tr>
            <!-- <tr>
              <th>Time</th>
              <td>Friday, Oct 22nd, 08:30PM - 9:00PM IST</td>
            </tr> -->
            <tr>
              <th>Guest</th>
              <td>{{userName}}<span><a>{{userEmail}}</a></span></td>
            </tr>
          </tbody>
        </table>
      </div>
      <button id="singlebutton" name="singlebutton button" class="btn btn-primary" style="width: 100%;
    margin-top: 20px;" (click)="closeThankDialog()">Close</button>
    </div>
  </div>
</div>
</ng-template>

<div
	style="width: 100%;
	background-color: rgba(0,0,0, .9);
  padding-top:200px;"
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngStyle]="{'display':sendingProcessStyle}">
	<div class="modal-dialog-style modal-dialog-centered-style" role="document" style="height: 100px;
    width: 35%; margin: 0 auto; text-align: center;">
		<div class="modal-content" style="padding: 30px; background-color: rgb(255,255,255); border-radius: 10px;">
			<div class="modal-body">
				<img class="main-loader-img" style="width: 140px;" src="assets/img/loader.svg" alt="">
			  <h6 style="font-size: 16px;">Please wait</h6>
			  <p>Confirming your meeting time..</p>
			</div>
		</div>
	</div>
</div>
